export default __webpack_public_path__ + "static/media/classexplain.eafbda3c.png";